import { render, staticRenderFns } from "./FuTablePagination.vue?vue&type=template&id=2e603a90&"
import script from "./FuTablePagination.vue?vue&type=script&lang=js&"
export * from "./FuTablePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports